import { useCallback, useRef, useState } from 'react';

/**
 * Защита от повторной отправки формы (двойной клик, Enter, медленная сеть).
 *
 * run(action) выполняет асинхронное действие и игнорирует новые вызовы, пока
 * предыдущее не завершилось. Блокировка стоит на ref и срабатывает мгновенно,
 * не дожидаясь перерисовки; isSubmitting нужен только чтобы отключить кнопку.
 */
export default function useSubmitLock() {
  const lockRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const run = useCallback(async (action) => {
    if (lockRef.current) return undefined;
    lockRef.current = true;
    setIsSubmitting(true);
    try {
      return await action();
    } finally {
      lockRef.current = false;
      setIsSubmitting(false);
    }
  }, []);

  return { isSubmitting, run };
}
